import moment from "moment";
import {
  App,
  Badge,
  Col,
  Divider,
  Flex,
  Row,
  Spin,
  Steps,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { CiCircleChevDown, CiCircleChevUp, CiLock } from "react-icons/ci";
import { LoadingOutlined } from "@ant-design/icons";
import React, { memo, useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
import { useJobDeposit } from "hook/bailiff/job/action/useJobDeposit";
import { MdAudiotrack } from "react-icons/md";
import { IoVideocam } from "react-icons/io5";

//str
// import doc from "asset/img/bailiff/doc.png";
import { JOB_STATUS } from "store/string";
import "./card_bailiff_job.css";
import { refineSpecificTimer, refineTimer } from "util/refine_timer.function";
import { useSetting } from "hook/default/setting/useSetting";
import numeral from "numeral";

const STATUS = ["waiting for deposit"];

const FORMAT_TIMER = "DD/MM/YYYY HH:mm";

const PROGRESS_ITEMS = [
  {
    key: "createAt",
    title: "Tải lên",
  },
  {
    key: "waitingDepositAt",
    title: "Báo giá và thanh toán",
    subTitle: "Click vào file để tiến hành thanh toán",
  },
  {
    key: "depositedAt",
    title: "Đã thanh toán",
  },
  {
    key: "transcriptAt",
    title: "AI biên dịch và chuyển âm",
  },
  {
    key: "supportingAt",
    title: "Nhóm hỗ trợ chỉnh sửa",
  },
  {
    key: "approvalAt",
    title: "Kiểm tra chất lượng",
  },
  {
    key: "completeAt",
    title: "Hoàn tất khâu kiểm tra",
  },
  {
    key: "readyForForwardingAt",
    title: "Sẵn sàng bàn giao",
  },
];

const CardBailiffJob = memo(({ data }) => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const { loading, handleDeposit } = useJobDeposit();
  const { ratio, durationToPrice } = useSetting();
  // const size = 80;
  const name = data?.name;
  const status = data?.status;
  const exist = JOB_STATUS?.find((j) => j?.value === status);
  const label = exist?.label;
  const color = exist?.color;
  const error = data?.error || "";
  const contentType = data?.contentType;
  const duration = data?.duration || 0;
  // const createAt = data?.createAt;
  const depositedAt = data?.depositedAt || null;
  // const labelCreate = moment(createAt?.toDate())?.format(FORMAT_TIMER);
  // const labelDepositAt = moment(depositedAt?.toDate())?.format(FORMAT_TIMER);
  const currentIndex = PROGRESS_ITEMS.findLastIndex(
    (item) => data?.[item.key] !== undefined,
  );
  const icon = <CiLock size={20} />;
  const type = name?.split(".")?.pop();
  const mediaIcon = contentType?.includes("video") ? (
    <IoVideocam className="!rounded-full text-blue-700" size={28} />
  ) : (
    <MdAudiotrack className="!rounded-full text-blue-700" size={28} />
  );
  const loadProcess = loading || !exist;

  // -------------------------- STATE ---------------------------
  const [show, setShow] = useState(true);
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChoose = () => {
    if (!data) return message.error("Data not found!");
    if (status === "waiting for deposit") {
      return handleDeposit(data);
    }

    return message.info(
      "File đang trong tiến trình xử lý, sẽ thông báo ngay khi hoàn tất!",
    );
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLoad = () => {
    if (!show || loadProcess || currentIndex === PROGRESS_ITEMS.length - 1) {
      return (
        <div className="my-4 flex flex-row gap-3">
          <Spin indicator={<LoadingOutlined spin />} />{" "}
          <span>Đang xử lý...</span>
        </div>
      );
    }
  };

  const renderDeposit = () => {
    if (status === "waiting for deposit") {
      const size = data?.size / 1024 / 1024;
      const second = duration;
      const items = renderItems({ data, show: true, currentIndex });
      return (
        <Tooltip overlay={renderOverlayDeposit()} placement="right">
          <div
            onClick={handleChoose}
            className="flex min-h-[100px] min-w-[150px] cursor-pointer flex-col gap-2 rounded-md border-[1px] bg-white p-5 hover:!border-blue-600"
          >
            <div className="flex flex-[0.7] flex-col gap-1">
              <div className="flex flex-row items-center gap-1">
                {mediaIcon}
                <Typography.Text
                  className="text-[16px] font-bold"
                  ellipsis={{ rows: 1 }}
                >
                  {name}
                </Typography.Text>
              </div>
              <div className="flex flex-row gap-2">
                <Tag className="border-[0.5px] border-gray-500">
                  {String(type).toLocaleUpperCase()}
                </Tag>
                {numeral(size).format("0,0.0")} MB •{" "}
                {numeral(second).format("0,0")} s • {icon}
              </div>
            </div>
            <Divider className="my-2"></Divider>
            <div>
              <Steps
                size="small"
                items={items}
                style={{ flex: "auto" }}
                orientation="vertical"
                variant="outlined"
                current={currentIndex}
                type="dot"
              />
              {renderLoad()}
            </div>
          </div>
        </Tooltip>
      );
    }
  };

  const renderShowItem = () => {
    const icon = !show ? <CiCircleChevDown /> : <CiCircleChevUp />;
    const label = !show ? "Ẩn đi" : "Hiện đầy đủ";
    return (
      <Tooltip title={label}>
        <div onClick={() => setShow((prev) => !prev)}>{icon}</div>
      </Tooltip>
    );
  };

  const renderError = () => {
    console.log({ status });
    if (status === "failed") {
      return (
        <div className="text-[12px] text-red-600">
          Lỗi: {error || "Đã có lỗi xảy ra!"}!
        </div>
      );
    }
  };

  const renderOverlayDeposit = () => {
    const size = data?.size / 1024 / 1024;
    const duration = data?.duration;
    const timer = refineTimer({ timer: duration });
    const labelCost = durationToPrice(duration);
    return (
      <div className="min-h-[200px] min-w-[250px] p-[16px]">
        <Row gutter={[16, 8]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Typography.Title level={4} className="!text-white">
              Báo giá Audio
            </Typography.Title>
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <b>Tên file:</b> {name}
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <b>Kích thước:</b> {size.toFixed(2)} MB
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <b>Thời lượng:</b> {timer}
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <b>Giá chuyển đổi:</b> {ratio.toFixed(2)} vnđ/1s
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <b>Chi phí chuyển đổi</b> {labelCost} vnđ
          </Col>

          <Col xl={24} lg={24} md={24} xs={24}>
            <p className="italic">Click vào file để tiến hành thanh toán</p>
          </Col>
        </Row>
      </div>
    );
  };

  const renderAnother = () => {
    if (STATUS?.includes(status)) return null;
    const size = data?.size / 1024 / 1024;
    const second = duration;
    const items = renderItems({ data, show, currentIndex });
    return (
      <div
        onClick={handleChoose}
        className="flex min-h-[100px] min-w-[150px] cursor-pointer flex-col gap-2 rounded-md border-[1px] bg-white p-5 hover:!border-blue-600"
      >
        <div className="flex flex-[0.7] flex-col gap-1">
          <div className="flex flex-row items-center gap-1">
            {mediaIcon}
            <Typography.Text
              className="text-[16px] font-bold"
              ellipsis={{ rows: 1 }}
            >
              {name}
            </Typography.Text>
          </div>
          <div className="flex flex-row gap-2">
            <Tag className="border-[0.5px] border-gray-500">
              {String(type).toLocaleUpperCase()}
            </Tag>
            {numeral(size).format("0,0.0")} MB • {numeral(second).format("0,0")}{" "}
            s • {icon}
          </div>
        </div>
        <Divider className="my-2">{renderShowItem()}</Divider>
        <div>
          <Steps
            size="small"
            items={items}
            style={{ flex: "auto" }}
            orientation="vertical"
            variant="outlined"
            current={currentIndex}
            type="dot"
          />
          {renderLoad()}
        </div>
        {renderEstimatedFinish()}
        {renderError()}
      </div>
    );
  };

  const renderEstimatedFinish = () => {
    if (!depositedAt) return null;
    return (
      <Typography.Text className="rounded-sm px-[4px] py-[2px] text-[12px] text-blue-600">
        <Badge status="processing" color={"blue"} /> Thời gian xử lý tối đa:{" "}
        {refineSpecificTimer({
          timer: duration * 6,
        })}{" "}
        (tính từ lúc thanh toán xong, không bao gồm giờ hành chính)
      </Typography.Text>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <>
      {renderDeposit()}
      {renderAnother()}
    </>
  );
});
export default CardBailiffJob;

const renderItems = ({ data, show = true, currentIndex }) => {
  let result = [];
  const reserve = PROGRESS_ITEMS;
  reserve?.forEach((item, index) => {
    const key = item?.key;
    const value = data?.[key] || null;
    const title = item?.title;
    const subTitle = item?.subTitle;

    if (!show) {
      return;
    }

    if (value) {
      const label = moment(value?.toDate())?.format(FORMAT_TIMER);

      if (index === 1 && currentIndex === 1) {
        result.push({
          title,
          content: (
            <Flex vertical>
              <span>{label}</span>
              <Typography.Text type="secondary" italic>
                {subTitle}
              </Typography.Text>
            </Flex>
          ),
        });
      } else {
        result.push({ title, content: label });
      }
    } else {
      const content =
        index === currentIndex + 1 && index < PROGRESS_ITEMS.length ? (
          <Flex align="center" gap={8}>
            <Spin indicator={<LoadingOutlined spin />} size="small" />
            Đang xử lý
          </Flex>
        ) : undefined;
      result.push({ title, content });
    }
  });

  return result;
};
